<template>
  <el-card v-if="!formDialog" class="h-full">
    <div class="h-full flex flex-col" v-if="currentComp === 'TABLE'">
      <div class="flex mb-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="风险点名称"
          v-model="equipSearchData.keywords"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择区域"
          v-model="equipSearchData.areaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <department-select
          ref="departmentSelect"
          class="mr-10px !w-50 mb-10px"
          v-model="equipSearchData.ownedUnitId"
        ></department-select>
        <el-select
          v-model="equipSearchData.evaluationLevel"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择风险等级"
          clearable
        >
          <el-option
            v-for="item in resultList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-button class="mb-10px" size="small" type="primary" @click="handleSearch('equip')"
          >搜索</el-button
        >
        <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
        <el-button
          class="mb-10px"
          size="small"
          type="danger"
          :disabled="!$hasAccess('delete')"
          @click="handleEvent(null, 'batchDelete')"
          >批量删除</el-button
        >
        <el-dropdown :disabled="!$hasAccess('import')" class="mr-10px ml-10px mb-10px">
          <el-button
            >{{ templateName || '导入' }}<i class="el-icon-arrow-down pl-5px"></i
          ></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              command="exportLS"
              @click.native="handleEvent(null, 'importLS')"
              :disabled="!$hasAccess('import')"
              >导入LS</el-dropdown-item
            >
            <el-dropdown-item
              command="exportLEC"
              @click.native="handleEvent(null, 'importLEC')"
              :disabled="!$hasAccess('import')"
              >导入LEC</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button
          size="small"
          @click="handleEvent(null, 'batchExport')"
          :disabled="!$hasAccess('export')"
          >导出</el-button
        > -->
      </div>
      <div class="flex-auto h-0px">
        <el-table
          :data="equipDataList"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          :span-method="spanMethod"
          v-loading="equipTableLoading"
          @selection-change="handleSelectionEquip"
          :row-class-name="rowClassName"
          :cell-class-name="setCellStyle"
          @cell-mouse-enter="handleMouseEnter"
          @cell-mouse-leave="handleMouseLeave"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="序号" prop="specialId" width="50"></el-table-column>
          <el-table-column label="风险点信息">
            <el-table-column
              label="作业活动名称"
              width="180"
              prop="jobName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="作业活动编码"
              width="180"
              prop="jobNo"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="作业活动内容"
              width="180"
              prop="jobContent"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="作业活动区域"
              width="180"
              prop="jobActivityAreaStr"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="实施单位"
              width="180"
              prop="jobImplementationUnitStr"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="涉及设备"
              width="180"
              prop="equipmentStr"
              show-overflow-tooltip
            ></el-table-column>
          </el-table-column>
          <el-table-column label="危险源信息">
            <el-table-column
              label="作业步骤"
              prop="jobStep"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="检查标准"
              prop="hiddenEvent"
              width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="危险有害因素分类"
              prop="harmElementType"
              width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="可能导致的事故类型"
              width="180"
              prop="accidentType"
              show-overflow-tooltip
            ></el-table-column>
          </el-table-column>
          <el-table-column
            label="LS评估方法"
            width="120"
            prop="riskRatingMethodLS"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="LEC评估方法"
            width="120"
            prop="riskRatingMethodLEC"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="D/R风险值"
            width="120"
            prop="dRiskValue"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="评价级别"
            width="80"
            prop="evaluationLevel"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="管控级别"
            width="80"
            prop="controlLevel"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="风险色" width="80" prop="riskText" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ riskColorTypes(scope.row.controlLevel || '低风险') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="管控层级"
            width="80"
            prop="controlHierarchyText"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="责任部门"
            width="80"
            prop="organizationUnitName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="责任人"
            width="80"
            prop="leaderName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="风险来源"
            width="180"
            prop="sourceOfRisk"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="值班电话"
            width="120"
            prop="dutyPhone"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="应急电话"
            width="120"
            prop="emergencyPhone"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="equipTotalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <bank-card-job
      :cardDetail="cardDetail"
      v-else-if="currentComp === 'CARD'"
      @cancel="checkComp('TABLE')"
    ></bank-card-job>

    <!-- 上传组件 -->
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
  <bank-job-form
    v-else
    :formProps="formProps"
    :formData="formData"
    @cancel="formDialog = false"
  ></bank-job-form>
</template>

<script>
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { JobActivityRiskThinkTankApi } from '@wiz-api/double-prevention-management'
import { wizUploadFile } from '@wiz-core/compts'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { riskColorTypes } from '@/components/safety/enumField/enumTypeMethods'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import BankCardJob from '../components/RiskIntelligenceBankTable/BankCardJob'
import BankJobForm from '../components/RiskIntelligenceBankTable/BankJobForm'

const areaApi = new AreaApi()
const jobActivityRiskThinkTankApi = new JobActivityRiskThinkTankApi()

export default {
  name: 'evaluate-job-table',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    DepartmentSelect,
    BankCardJob,
    BankJobForm,
    wizUploadFile,
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      templateName: '',
      formProps: {
        title: '新增作业风险智库',
        editType: 'create',
        visible: true,
      },
      formData: {},
      formDialog: false,
      cardDetail: null,
      currentComp: 'TABLE',
      cellIndex: -1,
      rowIndex: 1,
      position: 0,
      spanArrObj: {},
      value: '',
      areaList: [],
      selectionEquipData: [],
      resultList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        ownedUnitId: '',
        areaId: null,
        evaluationLevel: '',
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    riskColorTypes() {
      return (val) => {
        return riskColorTypes(val)
      }
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '生成风险应知卡',
            click: () => {
              return this.handleEvent(val, 'createRiskCard')
            },
            isShow: this.$hasAccess('createRiskCard'),
          },
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
        ]
      }
    },
  },
  mounted() {
    this.getEquipList()
    // 获取区域列表
    this.getAreaList()
  },
  methods: {
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.$refs.departmentSelect.userName = ''
      this.handleSearch()
    },
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 选中
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.jobActivityId
      })
    },
    // 获取合并行参数(数组)
    rowspan(data) {
      const list = []
      this.rowIndex = 1
      this.position = 0
      this.spanArrObj = {}
      _.forEach(data, (item, index) => {
        item.riskAssessStatusParent = item.riskAssessStatus
        if (
          item.jobSourcesDangerIdentifyAssessDtos &&
          item.jobSourcesDangerIdentifyAssessDtos.length > 0
        ) {
          const totalRisk = _.map(item.jobSourcesDangerIdentifyAssessDtos, (riskItem) => {
            return riskItem.controlLevel
          })
          if (totalRisk.includes('重大风险')) {
            item.totalRisk = 0
          } else if (totalRisk.includes('较大风险')) {
            item.totalRisk = 1
          } else if (totalRisk.includes('一般风险')) {
            item.totalRisk = 2
          } else if (totalRisk.includes('低风险')) {
            item.totalRisk = 3
          }
          _.forEach(item.jobSourcesDangerIdentifyAssessDtos, (ele) => {
            ele.cellIndex = index
            list.push({ ...item, ...ele })
          })
        } else {
          list.push({ ...item })
        }
      })
      list.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj.riskActivityRelationalId) {
            this.spanArrObj.riskActivityRelationalId = []
          }
          this.spanArrObj.riskActivityRelationalId.push(1)
          this.position = 0
          item.specialId = this.rowIndex
          this.rowIndex++
        } else if (
          list[index].riskActivityRelationalId === list[index - 1].riskActivityRelationalId
        ) {
          this.spanArrObj.riskActivityRelationalId[this.position] += 1
          this.spanArrObj.riskActivityRelationalId.push(0)
        } else {
          if (!this.spanArrObj.riskActivityRelationalId) {
            this.spanArrObj.riskActivityRelationalId = []
          }
          item.specialId = this.rowIndex
          this.rowIndex++
          this.spanArrObj.riskActivityRelationalId.push(1)
          this.position = index
        }
      })
      this.equipDataList = list
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20, 21, 22, 23, 24].includes(columnIndex)) {
        const _row = this.spanArrObj.riskActivityRelationalId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    // 鼠标进入单元格
    handleMouseEnter(row, column, cell, event) {
      _.forEach(this.equipDataList, (item, index) => {
        if (row.specialId === item.cellIndex) {
          this.cellIndex = row.cellIndex
        }
      })
    },
    // rowIndex添加类名
    rowClassName({ row, rowIndex }) {
      let r = -1
      _.forEach(this.equipDataList, (item) => {
        if (this.cellIndex === row.cellIndex) {
          r = rowIndex
        }
      })
      if (rowIndex === r) {
        return 'hover-row'
      }
    },
    // 设置列背景色
    setCellStyle(obj) {
      if (obj.columnIndex === 17) {
        let currentColorClass = null
        switch (obj.row.totalRisk) {
          case 0:
            // 红色
            currentColorClass = 'customebg-color-danger'
            break
          case 1:
            // 橙色
            currentColorClass = 'customebg-color-alarm'
            break
          case 2:
            // 黄色
            currentColorClass = 'customebg-color-risk'
            break
          case 3:
            // 蓝色
            currentColorClass = 'customebg-color-primary'
            break
          default:
            break
        }
        return currentColorClass
      }
    },
    // 鼠标离开单元格
    handleMouseLeave(row, column, cell, event) {
      this.cellIndex = -1
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'delete':
          this.$confirm('是否删除该记录，删除后无法恢复？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await jobActivityRiskThinkTankApi.callDelete(row.jobActivityId)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'createRiskCard':
          this.checkComp('CARD')
          this.cardDetail = row
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'batchDelete':
          if (!this.selectionEquipData || this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除选中记录，删除后无法恢复？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await jobActivityRiskThinkTankApi.deleteMany({
                ids: this.selectionEquipData,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'importLEC':
          this.templateName = '导入LEC'
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'importLS':
          this.templateName = '导入LS'
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        default:
          break
      }
    },
    // 下载模板
    async exportTemplate() {
      let err = null
      let res = null
      if (this.templateName === '导入LS') {
        ;[err, res] = await jobActivityRiskThinkTankApi.importFromExcelTemplateFileLS()
      } else {
        ;[err, res] = await jobActivityRiskThinkTankApi.importFromExcelTemplateFileLEC()
      }
      if (!err) {
        this.downLoadExcel(
          this.templateName === '导入LS' ? '作业活动清单LS模板' : '作业活动清单LEC模板',
          res
        )
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      let err = null
      let res = null
      if (this.templateName === '导入LEC') {
        ;[err, res] = await jobActivityRiskThinkTankApi.importFromExcelContentLEC_0({
          input: formData.get('input'),
        })
      } else {
        ;[err, res] = await jobActivityRiskThinkTankApi.importFromExcelContentLS_0({
          input: formData.get('input'),
        })
      }
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formData = this.$options.data().formData
      this.formData = row
      this.formDialog = true
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 作业活动列表
    async getEquipList() {
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await jobActivityRiskThinkTankApi.jobActivityRiskThinkTankPagedListQuery(
        data
      )
      if (!err) {
        this.rowspan(res.items)
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}

::v-deep .customebg-color-danger {
  background: #ff3a30 !important;
}
::v-deep .customebg-color-alarm {
  background: #ff9502 !important;
}

::v-deep .customebg-color-risk {
  background: #f8b200 !important;
}

::v-deep .customebg-color-primary {
  background: #0082f7 !important;
}
</style>
